import api from "../Api";

// helper: build auth headers
const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// جلب كل الطلبات (Admin)
export const getAllOrders = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get("/admin/all/orders", {
      headers,
      params: mergedParams,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching all orders:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};

// تفاصيل طلب واحد (Admin)
export const getOrderInfo = async (orderId, params = {}) => {
  if (!orderId) throw new Error("orderId is required.");

  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get(`/admin/order/info/${orderId}`, {
      headers,
      params: mergedParams,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching order info:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
// تحديث حالة الطلب
export const updateOrderStatus = async (orderId, status) => {
  if (!orderId) throw new Error("orderId is required");

  const normalizedStatus = String(status || "").trim();
  if (!normalizedStatus) throw new Error("status is required");

  const headers = {
    ...getAuthHeaders(),
    "Content-Type": "multipart/form-data",
  };

  const formData = new FormData();
  formData.append("status", normalizedStatus);

  const response = await api.post(
    `/admin/update/order/status/${orderId}`,
    formData,
    {
      headers,
      params: { api_password: "EcommercApp@2026_$" },
    }
  );

  return response.data;
};

// جلب الطلبات المعلقة (pending)
export const getPendingOrders = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get(`/admin/pending/orders`, {
      headers,
      params: mergedParams,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching pending orders:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};

// تقرير المدفوعات (Admin)
export const getPaymentsReport = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get("/admin/payments/report", {
      headers,
      params: mergedParams,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching payments report:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
